import React, { Component } from "react"
import Cookies from "js-cookie"

import brandMetadata from "../../../../data/brandMetadata.json" // eslint-disable-line import/no-restricted-paths
import NewSelectField from "common/components/NewSelectField/NewSelectField"

class SetBrand extends Component {
  constructor(props) {
    super(props)
    this.state = {
      brandingId: Cookies.get("forced_brand"),
    }
  }

  setBrand = brandingId => {
    this.setState({ brandingId })
    Cookies.set("forced_brand", brandingId, { expires: 1 })
    document.location.reload()
  }

  render() {
    const options = brandMetadata.brands.map(x => ({ value: x, label: x }))
    options.unshift({ value: "", label: "Autodetect brand (default)" })

    return (
      <NewSelectField
        label="Brand"
        value={this.state.brandingId}
        options={options}
        onChange={this.setBrand}
      />
    )
  }
}

export default SetBrand
